import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {makeStyles} from "@mui/styles";
import {isMobile} from "react-device-detect";
import Draggable from "react-draggable";
import {Box} from "@mui/material";
import {resetMobileZoom} from "../../com/globalsFunctions/globalFunctions";
import {AddToMyListPromoContentPopup} from "../addtobasket/addToMyListPromoContentPopup";

const useStyles = makeStyles(() => ({
    shelfPromoDetailsPopupWrapper: (props: any) => ({
        background: `white`,

        position: `fixed`,
        zIndex: 4,
//opacity: 0;

        opacity: `1`,
        // height: props.isExpandedPopup ? `76vh` : `${document.documentElement.clientHeight}px`,
        direction: props.direction,

        '&.addToListMenuForDesktopIsHebrew': {
            right: `auto`,
            left: `0`,
        },

        // width: `50%`,
        // height: '82%',
        // top: `50px`,
        // left: `0`,
        // maxHeight: `${document.documentElement.clientHeight}px`,
        // border: `1px solid #858585`,
    }),
    addToListHidden: {
        display: `none`,
    },

}))

export const ShelfPromoDetailsPopup = () => {
    //states
    const { flyersBranch, storeData, shelvesScreen, shelfPromo, detailsBranch, controlsBranch , addToMyListOneItemData, selectedSpot} = useSelector((state: IAppState) => state);
    const {showBasket, isPortraitView} = controlsBranch;
    const storeSettings = storeData.isFromFlyer ? flyersBranch.data : shelvesScreen.data?.storeSetting;
    const stylesProperties = {
        direction: storeSettings?.dir?.toLowerCase(),
        fontFamily: storeSettings?.font?.toLowerCase()
    }
    const classes = useStyles(stylesProperties);
    const [xForShelfPromoPopup, setXForShelfPromoPopup] = useState<number>(0);
    const [yForShelfPromoPopup, setYForShelfPromoPopup] = useState<number>(0);
    //effects
    const isPricelessFlyer = storeSettings?.typeCode === 3;
    const isMobileView = isMobile || isPortraitView;

    useEffect(() => {

        if (!isMobileView) {
            setYForShelfPromoPopup(0);
            setXForShelfPromoPopup(0);
        }
        if(isMobileView){
            resetMobileZoom();
        }
        return () => {
            if(isMobileView){
                resetMobileZoom();
            }
        }
    }, []);

    //callback
    const handleEvent = (e: any, data: any) => {
        localStorage.setItem(`lastXShelfPromo`, JSON.stringify(data.lastX));
        localStorage.setItem(`lastYShelfPromo`, JSON.stringify(data.lastY));
        setXForShelfPromoPopup(data.lastX);
        setYForShelfPromoPopup(data.lastY);
    }
    let widthForPopupWrapper: string = `60vw`;
    let rightForPopupWrapper: string = `20vw`;
    if(shelfPromo.data?.items.length === 1){
        if(isPricelessFlyer){
            widthForPopupWrapper = `26vw`;
            rightForPopupWrapper = `36vw`;
        } else {
            widthForPopupWrapper = `50vw`;
            rightForPopupWrapper = `25vw`;
        }
    } else if (shelfPromo.data?.items.length === 2){
        widthForPopupWrapper = `40vw`;
        rightForPopupWrapper = `30vw`;
    }


    if(shelfPromo.isOpen){
        if(isMobileView){
            return (
                <Box style={{height: `100%`}} className={`${(Boolean(detailsBranch) || showBasket || Boolean(addToMyListOneItemData.data)) ? classes.addToListHidden : ''}`}>
                    <AddToMyListPromoContentPopup isLoading={shelfPromo.isLoading} selectedPromo={shelfPromo.data} isExpanded={true}/>
                </Box>
            )
        }
        if (selectedSpot.isExpanded) {
            return (
                <Draggable
                    bounds="body"
                    handle="#draggable-dialog-title"
                    onStop={handleEvent}
                    defaultPosition={{x: xForShelfPromoPopup, y: yForShelfPromoPopup}}
                    position={{x: xForShelfPromoPopup, y: yForShelfPromoPopup}}
                >

                    <Box
                        className={`${classes.shelfPromoDetailsPopupWrapper}`}
                        sx={{
                            width: widthForPopupWrapper,
                            top: `10vh`,
                            right: rightForPopupWrapper,
                        }}
                    >
                        <AddToMyListPromoContentPopup isLoading={shelfPromo.isLoading} selectedPromo={shelfPromo.data} isExpanded={selectedSpot.isExpanded}/>
                    </Box>
                </Draggable>
            );
        } else {
            return (
                <Box
                    className={`${classes.shelfPromoDetailsPopupWrapper} ${storeSettings?.dir?.toLowerCase() === "rtl" ? `addToListMenuForDesktopIsHebrew` : ''}`}
                    sx={{
                        width: `430px`,
                        right: `0`,
                        top: `60px`,
                        maxHeight: `${document.documentElement.clientHeight}px`,
                    }}
                >
                    <AddToMyListPromoContentPopup isLoading={shelfPromo.isLoading} selectedPromo={shelfPromo.data} isExpanded={selectedSpot.isExpanded}/>
                </Box>
            )
        }
/*

        return (
            <Draggable
                bounds="body"
                handle="#draggable-dialog-title"
                onStop={handleEvent}
                defaultPosition={{x: xForShelfPromoPopup, y: yForShelfPromoPopup}}
                position={{x: xForShelfPromoPopup, y: yForShelfPromoPopup}}
            >

                <Box
                    className={`${classes.shelfPromoDetailsPopupWrapper}`}
                    sx={{
                        width: widthForPopupWrapper,
                        top: `10vh`,
                        right: rightForPopupWrapper,
                    }}
                >
                    <AddToMyListPromoContentPopup isLoading={shelfPromo.isLoading} selectedPromo={shelfPromo.data} isExpanded={true}/>
                </Box>
            </Draggable>
        )
*/
    } else {
        return (
            <></>
        )
    }
}